<template>
	<div
			id="services-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<swiper :options="swiperOption" ref="mySwiper7">
			<swiper-slide>
				<div style="height: 100%; background-image: url('../assets/img/cm1.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<h1 class="page__title-white">{{ $t('Our_clients') }}</h1>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div id="quote-form" class="page">
			<h1 class="page__title">{{ $t('Our_clients') }}</h1>
			<hr class="page__hr">

			{{ $t('Clients_text_01') }}:





			<ul>
				<li><strong>{{ $t('Individuals') }}</strong>.
				{{ $t('Clients_text_02') }}.




				</li>
				<li><strong>{{ $t('Law_firms') }} {{ $t('and') }} {{ $t('Auditors') }}</strong>.
				{{ $t('Clients_text_03') }}.
				</li>
				<li><strong>{{ $t('Private_Enterprises') }} {{ $t('and') }} {{ $t('Financial_Entities') }}</strong>.
							{{ $t('Clients_text_04') }}.</li>
				<li><strong>{{ $t('Public_Administrations') }}</strong>.</li>
				<li><strong>{{ $t('Mutual_insurance_companies') }}, {{ $t('Hospitals') }} {{ $t('and') }} {{ $t('Medical_centers') }}</strong>.</li>
				<li><strong>{{ $t('Cooperatives') }}</strong>.</li>
				<li><strong>{{ $t('Foundations') }}</strong>.</li>
				<li><strong>{{ $t('Property_developers') }}</strong>.</li>
				<li><strong>{{ $t('Sports_clubs') }}</strong>.</li>
				<li><strong>{{ $t('Insurance_companies') }}</strong>.</li>
				<li><strong>{{ $t('Investment_groups') }}</strong>.</li>
				<li><strong>{{ $t('Hotels') }} {{ $t('and') }} {{ $t('Restaurants') }}</strong>.</li>
				<li><strong>{{ $t('Others') }}</strong>.</li>
			</ul>

		</div>
		<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Message from '../components/Message.vue'
    import FooterBar from '../components/FooterBar.vue'
    import NavBar from '../components/NavBar.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import LogoBar from '../components/LogoBar.vue'

    export default {
        name: 'our-clients',

        mixins: [localStorageMixin],

        components: {
            Message,
            FooterBar,
            LogoBar,
            NavBar,
            swiper,
            swiperSlide
        },

        data: () => ({

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        }),

        computed: {
            ...mapGetters(['user',
                'theme'])
        },

        methods: {
            ...mapActions(['LOG_IN_USER'
            ]),
            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Services'
            }
        }

    }
</script>

<style scoped>
	.swiper-container {
		height: 40vh;
		width: 100%;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}
</style>


// WEBPACK FOOTER //
// OurClients.vue?0323ebdc